import { PropsWithChildren } from 'react';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

export const CalculatorRightColumn = ({ children }: PropsWithChildren) => (
    <div className="vss-calculator-right-column">

        <div className="vss-calculator-right-column__arrow">
            <ArrowRightIcon/>
        </div>

        <div className="vss-calculator-right-column__inputs">
            {children}
        </div>
    </div>
);
